import { Button } from 'antd';
import React, { useCallback, useRef } from 'react';

import { PinnedPanel } from '../../../../../../components/PinnedPanel';
import Btn from '../../../../../../components/btn';
import { CreateNewWorkSchedule } from '../CreateNewWorkSchedule/CreateNewWorkSchedule';
import { CreateNewWorkScheduleByPeriod } from '../CreateNewWorkScheduleByPeriod/CreateNewWorkScheduleByPeriod';
import { ScheduleCalendar } from '../ScheduleCalendar/ScheduleCalendar';
import { Schedules } from '../Schedules/Schedules';
import styles from '../../WorkSchedules.module.scss';

export const WorkScheduleContent = ({
  calendar,
  createByPeriodForm,
  createGroupForm,
  renderCompanySelect,
  renderToolbar,
  scheduleList,
  selectedSchedule,
}) => {
  const schedulePanelRef = useRef(null);
  const hasSeparateCompanyPanel = typeof renderCompanySelect === 'function';
  const handleCompactCalendarEnable = useCallback(() => {
    if (schedulePanelRef.current) {
      schedulePanelRef.current.unpin();
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      {typeof renderToolbar === 'function' && (
        <div>
          {renderToolbar(
            hasSeparateCompanyPanel ? { hideCompanySelect: true } : undefined
          )}
        </div>
      )}
      {hasSeparateCompanyPanel && (
        <div className={styles.companySelectionPanel}>
          {renderCompanySelect({
            btnProps: { className: styles.companySelectionControl },
          })}
        </div>
      )}
      {createGroupForm.isVisible && (
        <CreateNewWorkSchedule
          key={createGroupForm.key}
          schedule={createGroupForm.schedule}
          onCancel={createGroupForm.onCancel}
          onDirtyChange={createGroupForm.onDirtyChange}
          onSubmit={createGroupForm.onSubmit}
          isSubmitting={createGroupForm.isSubmitting}
        />
      )}
      {createByPeriodForm.isVisible ? (
        <CreateNewWorkScheduleByPeriod
          key={createByPeriodForm.key}
          companyId={createByPeriodForm.companyId}
          mode={createByPeriodForm.mode}
          parentScheduleId={createByPeriodForm.parentScheduleId}
          parentScheduleName={createByPeriodForm.parentScheduleName}
          schedule={createByPeriodForm.schedule}
          onCancel={createByPeriodForm.onCancel}
          onDraftCreate={createByPeriodForm.onDraftCreate}
          onDirtyChange={createByPeriodForm.onDirtyChange}
          isSubmitting={createByPeriodForm.isSubmitting}
        />
      ) : (
        <div className={styles.root}>
          <PinnedPanel
            className={styles.schedulePanel}
            header={
              <div className={styles.schedulePanelHeader}>
                <div className={styles.schedulePanelHeading}>
                  {scheduleList.showBackButton ? (
                    <Button
                      type="link"
                      icon="left"
                      className={styles.schedulePanelBackButton}
                      onClick={scheduleList.onBack}
                    >
                      Назад
                    </Button>
                  ) : (
                    <h2 className={styles.schedulePanelTitle}>
                      {scheduleList.title || 'Графики'}
                    </h2>
                  )}
                  <Btn
                    icon={scheduleList.createButtonIcon || 'plus'}
                    className={styles.createScheduleButton}
                    onClick={scheduleList.onCreateButtonClick}
                  >
                    {scheduleList.createButtonText || 'Новый график'}
                  </Btn>
                </div>
                {scheduleList.showBackButton && (
                  <h2 className={styles.schedulePanelTitle}>
                    {scheduleList.title || 'Графики'}
                  </h2>
                )}
              </div>
            }
            ref={schedulePanelRef}
            triggerTooltipTitle="Показать список графиков"
            pinTooltipTitle="Закрепить панель"
            unpinTooltipTitle="Открепить панель"
          >
            {({ closeOverlaysKey, onOverlayVisibleChange }) => (
              <Schedules
                schedules={scheduleList.schedules}
                isLoading={scheduleList.isLoading}
                selectedSchedule={scheduleList.selectedSchedule}
                showScheduleDetails={scheduleList.showScheduleDetails}
                showPeriodFilter={scheduleList.showPeriodFilter}
                closeOverlaysKey={closeOverlaysKey}
                onActionPopoverVisibleChange={onOverlayVisibleChange}
                onSelectSchedule={scheduleList.onSelectSchedule}
                onEditSchedule={scheduleList.onEditSchedule}
                onDuplicateSchedule={scheduleList.onDuplicateSchedule}
                onDeleteSchedule={scheduleList.onDeleteSchedule}
              />
            )}
          </PinnedPanel>
          <div className={styles.calendar}>
            {selectedSchedule ? (
              <ScheduleCalendar
                companyId={calendar.companyId}
                schedules={calendar.selectedSchedules}
                enableIntervalAssignment={calendar.enableIntervalAssignment}
                canSaveIntervals={calendar.canSaveIntervals}
                onAssignIntervals={calendar.onAssignIntervals}
                onBackIntervals={calendar.onBackIntervals}
                onCancelIntervals={calendar.onCancelIntervals}
                onCompactModeEnable={handleCompactCalendarEnable}
                onSaveIntervals={calendar.onSaveIntervals}
              />
            ) : (
              <div className={styles.emptyCalendar}>Нет данных</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
